import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportTableComponent } from '@app/components';
import { DialogComponent } from '@app/components/platform/dialog/dialog.component';
import { TimeTrackingDateFormatDashes } from '@app/modules/time-tracking/meta/time-tracking.meta';
import { FileHelperService, NotifyService } from '@app/services';
import moment, { Moment } from 'moment';
import { ReportFilter } from '../../interfaces/report-filter.interface';
import { Report } from '../../services/queries/report';

@Component({
    templateUrl: './compensation-report.view.html',
})
export class CompensationReportView implements OnInit {
    @ViewChild('filterModal') filterModal!: DialogComponent;
    @ViewChild('reportTable') reportTable!: ReportTableComponent;

    report!: Report;
    isLoading = false;
    startDate: Moment = moment().startOf('year');
    endDate: Moment = moment().endOf('year');
    filters: ReportFilter[] = [];

    isFilterModalOpen = false;

    constructor(
        private readonly fileService: FileHelperService,
        private readonly notify: NotifyService
    ) {}

    ngOnInit(): void {
        this.loadReport();
    }

    onExport(contentType: string): void {
        this.report.export(contentType).catch(() => {
            this.notify.error('reporting.reports.errorExportingReport');
        });
    }

    onFilter(filters: ReportFilter[]): void {
        this.filters = filters;
        this.startDate = moment(filters.find((item) => item.name === 'startAt')?.value, TimeTrackingDateFormatDashes);
        this.endDate = moment(filters.find((item) => item.name === 'endAt')?.value, TimeTrackingDateFormatDashes);
        this.isFilterModalOpen = false;
        this.report
            .filters(this.filters)
            .page(1)
            .get()
            .then((report: Report) => {
                this.report = report;
                this.reportTable.setPaginationData();
            })
            .catch((err) => this.notify.error(err))
            .finally(() => (this.isLoading = false));
    }

    private async loadReport(): Promise<void> {
        this.isLoading = true;

        try {
            this.report = await new Report(this.fileService)
                .name('compensationReport')
                .filters(
                    this.filters.length
                        ? this.filters
                        : [
                              {
                                  name: 'startAt',
                                  value: this.startDate.format(TimeTrackingDateFormatDashes),
                              },
                              {
                                  name: 'endAt',
                                  value: this.endDate.format(TimeTrackingDateFormatDashes),
                              },
                          ]
                )
                .page(1)
                .get();
        } catch (err) {
            this.notify.error(err);
        } finally {
            this.isLoading = false;
        }
    }
}
